import { Clock, Lock, CalendarClock, Hourglass, BadgeCheck, Ban, ExternalLink } from 'lucide-react';

export const INVESTMENT_STATUS = {
    pending: { label: 'Pendiente', cls: 'bg-amber-500/15 text-amber-300 border-amber-500/30', Icon: Clock },
    reserved: { label: 'Reservada', cls: 'bg-emerald-500/15 text-emerald-300 border-emerald-500/30', Icon: Lock },
    coming_soon: { label: 'Disponible próximamente', cls: 'bg-sky-500/15 text-sky-300 border-sky-500/30', Icon: CalendarClock },
};

export const PAYMENT_STATUS = {
    submitted: { label: 'Pago enviado · en verificación', cls: 'bg-violet-500/15 text-violet-300 border-violet-500/30', Icon: Hourglass },
    verified: { label: 'Pago verificado', cls: 'bg-emerald-500/15 text-emerald-300 border-emerald-500/30', Icon: BadgeCheck },
    rejected: { label: 'Pago rechazado', cls: 'bg-red-500/15 text-red-300 border-red-500/30', Icon: Ban },
};

export const PaymentStatusBadge = ({ payment, testId }) => {
    if (!payment) return null;
    const st = PAYMENT_STATUS[payment.status] || PAYMENT_STATUS.submitted;
    return (
        <span className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-md border text-[11px] font-semibold whitespace-nowrap ${st.cls}`} data-testid={testId}>
            <st.Icon className="w-3 h-3" /> {st.label}
        </span>
    );
};

export const TxHashLink = ({ payment, testId }) => payment?.tx_hash ? (
    <a href={payment.explorer_url} target="_blank" rel="noreferrer" className="inline-flex items-center gap-1 font-mono text-[11px] text-[#7CB1E5] hover:text-white break-all" data-testid={testId}>
        {payment.tx_hash.slice(0, 10)}…{payment.tx_hash.slice(-8)} <ExternalLink className="w-3 h-3 flex-shrink-0" />
    </a>
) : null;

export const CRYPTO_OPTIONS = [
    { key: 'BTC', label: 'Bitcoin', sub: 'BTC', color: '#f7931a' },
    { key: 'USDT_TRC20', label: 'USDT', sub: 'TRC20 · Tron', color: '#26a17b' },
];

export const fmtDate = (d) => d ? new Date(d).toLocaleDateString('es-ES', { day: '2-digit', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' }) : '—';
export const fmtEur = (a) => `${Number(a || 0).toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} €`;

export const InvestmentStatusBadge = ({ status, testId }) => {
    const st = INVESTMENT_STATUS[status] || INVESTMENT_STATUS.pending;
    return (
        <span className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-md border text-[11px] font-semibold whitespace-nowrap ${st.cls}`} data-testid={testId}>
            <st.Icon className="w-3 h-3" /> {st.label}
        </span>
    );
};

export const CryptoChip = ({ crypto }) => {
    const c = CRYPTO_OPTIONS.find((o) => o.key === crypto) || CRYPTO_OPTIONS[0];
    return (
        <span className="inline-flex items-center gap-1.5 text-xs text-slate-300">
            <span className="w-2 h-2 rounded-full" style={{ background: c.color }} /> {c.label} <span className="text-slate-500">{c.sub}</span>
        </span>
    );
};
